import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import LabelIcon from '@material-ui/icons/Label';
import Checkbox from '@material-ui/core/Checkbox';
import {
  FormControl,
} from '@material-ui/core';

export const StyledContainer = styled.div`

  flex: 0 0 177px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-sizing: border-box;
`;

export const StyledFormControl = styled(FormControl)`
  && {
    width: 177px; 
    background: 'white',
  }  

  & > div.MuiOutlinedInput-root {   
      border-radius: 0; 
      background: 'white',
  }    
    
`;

interface ISelectProps {
  disabled: boolean;
}

export const useStyles = makeStyles({
  select: {
    minWidth: 177,
    background: (props: ISelectProps) => props.disabled ? '#DEDEDE' : 'white',
    color: (props: ISelectProps) => props.disabled ? '#A1A1A1' : '#304F5A',
    border: 'none',
    borderRadius: 0,
    paddingLeft: 40,
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    boxShadow: '0px 5px 8px -3px rgba(0,0,0,0.14)',
    fontSize: 12,
    fontFamily: 'Cairo',
    fontWeight: 'bold',
    boxSizing: 'border-box',
    '&:focus': {
      background: 'white',
      borderRadius: 0,
      border: '1px solid #8DC63F',
    },
  },
  icon: {
    color: (props: ISelectProps) => props.disabled ? '#A1A1A1' : '#304F5A',
    marginTop: 0,
    right: 2,
    position: 'absolute',
    flexShrink: 0,
    userSelect: 'none',
    pointerEvents: 'none',
    fontSize: 22,
  },
  paper: {
    borderRadius: 0,
    marginTop: 8,
    border: '1px solid #8DC63F',
    maxHeight: '170px',
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    background: 'white',
    '& li': {
      paddingTop: 5,
      paddingBottom: 5,
      fontSize: 8,
      color: '#304F5A',
      fontFamily: 'Cairo',
      fontWeight: 'normal',
    },
    '& li:hover': {
      background: '#E3E3E3',
    },
    '& li.Mui-selected': {
      color: 'white',
      background: 'transparent',
    },
    '& li.Mui-selected:hover': {
      background: '#E3E3E3',
    },
  },
});

interface IIconProps {
  $disabled: boolean;
}

export const StyledDecorativeIcon = styled(LabelIcon)`

  && {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 50%;
    margin-top: -7.5px;
    left: 10px;
    color: ${(props: IIconProps) => props.$disabled ? '#A1A1A1' : '#304F5A'};
  }
 
`;

export const StyledMenuItemCheckbox = styled(Checkbox)`
  
  && {
    padding: 0;
    margin: 0;
    margin-right: 10px;
  }

  & svg {
    width: 20px;
  }
  
`;

export const StyledMenuItemTitle = styled.span`

  padding: 0;
  margin: 0;
  color: #304F5A;
  font-size: 8px;
  font-weight: normal;
  font-family: Cairo;
`;
